export default __webpack_public_path__ + "static/media/tutor.9e2821f2.svg";